import { Component, OnInit } from "@angular/core";
import { IUnavailability } from "@edp-models/unavailability.model";
import { UnavailabilityService } from "@edp-services/unavailability.service";

@Component({
    selector: "edp-unavailability",
    templateUrl: "./edp-unavailability.component.html",
    styleUrls: ["./edp-unavailability.component.scss"],
})
export class EdpUnavailabilityComponent implements OnInit {
    data: IUnavailability | null;

    constructor(private unavailabilityService: UnavailabilityService) { }

    ngOnInit(): void {
        this.unavailabilityService.unavailability$.subscribe(data => this.data = data);
    }

}
